import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Form, InputNumber, Select } from 'antd';
import { READWITH, QueryOrder, QueryDetail, errorCatch } from 'fennec-ui'



import { useState } from 'react';

const { Option } = Select;

export default function KategoryaUchastnikovSeriiUpdate(props) {
    const { auth, form, object } = props;
    const dispatch = useDispatch();

    const [kategoriyaUchastnikov, setKategoriyaUchastnikov] = useState([]);
    const [tantsevalnayaDistsiplina, setTantsevalnayaDistsiplina] = useState([]);
    useEffect(() => {
        form.resetFields();
        READWITH(auth, "KategoriiUchastnikov", [
            QueryOrder("id", "ASC"),
            QueryDetail("model")
        ], ({data}) => {
            setKategoriyaUchastnikov(data);
        }, errorCatch);

        READWITH(auth, "TantsevalnieDistsiplini", [
            QueryOrder("id", "ASC"),
            QueryDetail("model")
        ], ({data}) => {
            setTantsevalnayaDistsiplina(data);
        }, errorCatch);
    }, []);
    const kategoriyaUchastnikovOptions = kategoriyaUchastnikov?.map((i) => <Option key={i.ID} item={i} value={i.ID} label={i.nazvanie}>{i.nazvanie}</Option>);
    const tantsevalnayaDistsiplinaOptions = tantsevalnayaDistsiplina?.map((i) => <Option key={i.ID} item={i} value={i.ID} label={i.nazvanie}>{i.nazvanie}</Option>);
    return (
        <>
            <Form
                form={props.form}
                onFinish={props.submit}
                labelAlign={"left"}
                layout={"vertical"}
                initialValues={{
                    ...object
                }}
            >
                <Form.Item label={"Танцевальная дисциплина"} 
                    name="tantsevalnayaDistsiplinaID"
                    rules={[
                        { required: false, message: 'Пожалуйста, введите танцевальную дисциплину!' }
                    ]}
                >
                    <Select
                        disabled
                        allowClear
                        showSearch
                        optionFilterProp="children"
                        optionLabelProp="label"
                        filterOption={(input, option) =>
                            option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                        }
                        filterSort={(optionA, optionB) =>
                            optionA.children.toLowerCase().localeCompare(optionB.children.toLowerCase())
                        }
                    >
                        {tantsevalnayaDistsiplinaOptions}
                    </Select>
                </Form.Item>
                <Form.Item
                    name={"kategoriyaUchastnikovID"}
                    label={"Категория участников"}
                    rules={[{ required: false, message: 'Укажите категорию участников!' }]}
                >
                    <Select
                        disabled
                        allowClear
                        showSearch
                        optionFilterProp="children"
                        optionLabelProp="label"
                        filterOption={(input, option) =>
                            option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                        }
                        filterSort={(optionA, optionB) =>
                            optionA.children.toLowerCase().localeCompare(optionB.children.toLowerCase())
                        }
                    >
                        {kategoriyaUchastnikovOptions}
                    </Select>
                </Form.Item>
                <Form.Item
                    label={"Количество лучших результатов в итоговой сумме (коэф. 1)"}
                    name={"kolvoLuchshikhRezKoef1"}
                    rules={[{ required: true, message: 'Пожалуйста, укажите количество лучших результатов в итоговой сумме (коэф. 1)!' }]}
                >
                    <InputNumber />
                </Form.Item>
                <Form.Item
                    label={"Количество лучших результатов в итоговой сумме (коэф. 2)"}
                    name={"kolvoLuchshikhRezKoef2"}
                    rules={[{ required: false, message: 'Пожалуйста, укажите количество лучших результатов в итоговой сумме (коэф. 2)!' }]}
                >
                    <InputNumber />
                </Form.Item>
                <Form.Item
                    label={"Подсвечивать зеленым сумму более или равную"}
                    name={"podsvechivatZelenim"}
                    rules={[{ required: false, message: 'Пожалуйста, укажите "Подсвечивать зеленым сумму более или равную"!' }]}
                >
                    <InputNumber />
                </Form.Item>
                <Form.Item
                    label={"Подсвечивать лучших результатов"}
                    name={"podsvechivatLuchshikhRezultatov"}
                    rules={[{ required: false, message: 'Пожалуйста, укажите "Подсвечивать лучших результатов"!' }]}
                >
                    <InputNumber />
                </Form.Item>
            </Form>
        </>
    );
}
